"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentAudienceMappingsResponseToJSON = exports.ExperimentAudienceMappingsResponseFromJSONTyped = exports.ExperimentAudienceMappingsResponseFromJSON = exports.instanceOfExperimentAudienceMappingsResponse = void 0;
var runtime_1 = require("../runtime");
var AudienceMapping_1 = require("./AudienceMapping");
/**
 * Check if a given object implements the ExperimentAudienceMappingsResponse interface.
 */
function instanceOfExperimentAudienceMappingsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfExperimentAudienceMappingsResponse = instanceOfExperimentAudienceMappingsResponse;
function ExperimentAudienceMappingsResponseFromJSON(json) {
    return ExperimentAudienceMappingsResponseFromJSONTyped(json, false);
}
exports.ExperimentAudienceMappingsResponseFromJSON = ExperimentAudienceMappingsResponseFromJSON;
function ExperimentAudienceMappingsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'experimentId': !(0, runtime_1.exists)(json, 'experiment_id') ? undefined : json['experiment_id'],
        'audiences': !(0, runtime_1.exists)(json, 'audiences') ? undefined : (json['audiences'].map(AudienceMapping_1.AudienceMappingFromJSON)),
    };
}
exports.ExperimentAudienceMappingsResponseFromJSONTyped = ExperimentAudienceMappingsResponseFromJSONTyped;
function ExperimentAudienceMappingsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'experiment_id': value.experimentId,
        'audiences': value.audiences === undefined ? undefined : (value.audiences.map(AudienceMapping_1.AudienceMappingToJSON)),
    };
}
exports.ExperimentAudienceMappingsResponseToJSON = ExperimentAudienceMappingsResponseToJSON;
